import gql from 'graphql-tag';

const GET_MARKS = gql`
  query getMarks($subject: String!, $section: String, $subsection: String, $curriculum: [String]) {
    markChoices(subject: $subject, section: $section, subsection: $subsection, curriculum: $curriculum)
  }
`;

export default GET_MARKS;
